import registry from "../data/dspProviderRegistry.json";

// Generated from Backend's provider registry. Inventory labels alone do not
// identify, admit, verify, or enable a provider.
const compact = (value) => String(value ?? "").trim().toLowerCase().replace(/[^a-z0-9]/g, "");
export const PROVIDER_SURFACE_REGISTRY = Object.freeze(Object.fromEntries(
  registry.providers.map((provider) => [provider.key, Object.freeze({ ...provider, optimizationSupported: false })])
));
export const normalizeProviderSurfaceKey = (value) => {
  const token = compact(value);
  return Object.values(PROVIDER_SURFACE_REGISTRY).find((provider) => provider.aliases.some((alias) => compact(alias) === token))?.key || "";
};
export const providerSurfaceLabel = (value) => PROVIDER_SURFACE_REGISTRY[normalizeProviderSurfaceKey(value)]?.label || "";
export const providerPlannerKey = (value) => PROVIDER_SURFACE_REGISTRY[normalizeProviderSurfaceKey(value)]?.plannerKey || "";
